import { render, staticRenderFns } from "./VehicleDetailBox.vue?vue&type=template&id=041f5d2b&scoped=true&lang=pug"
import script from "./VehicleDetailBox.vue?vue&type=script&lang=js"
export * from "./VehicleDetailBox.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetailBox.vue?vue&type=style&index=0&id=041f5d2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041f5d2b",
  null
  
)

export default component.exports